<template>
  <div class="check-box">
    <div class="form-item">
      <div class="form-label">手机号</div>
      <div class="form-input">
        <input v-model="mobile" type="number" maxlength="11">
      </div>
    </div>
    <div class="form-item">
      <div class="form-label">请输入劵编码</div>
      <div class="form-input">
        <input v-model="code" type="text" maxlength="50">
      </div>
    </div>
    <div class="form-item">
      <van-button :loading="loading" class="form-btn" type="primary" loading-text="核销中" block @click="handleCheck" color="#4F7DFF">核销</van-button>
    </div>
  </div>
</template>

<script>
import { Toast, Button } from 'vant'
import { checkCoupon } from '@/api/drugPrize'

export default {
  components: {
    [Button.name]: Button
  },
  data () {
    return {
      loading: false,
      code: null,
      mobile: null
    }
  },
  methods: {
    handleCheck () {
      if (!this.mobile) {
        Toast({
          message: '手机号不能为空'
        })
        return
      }
      if (!this.checkPhone(this.mobile)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      }
      if (!this.code) {
        Toast({
          message: '劵编码不能为空'
        })
        return
      }
      const requestData = {
        mobile: this.mobile,
        code: this.code
      }
      this.loading = true
      checkCoupon(requestData).then((res) => {
        this.loading = false
        if (res.data.code === 200) {
          if (res.data.result === true) {
            Toast('核销成功')
          } else {
            Toast({
              message: res.data.message
            })
          }
        } else {
          Toast({
            message: res.data.message
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    checkPhone (mobile) {
      let reg = /^1[3456789]\d{9}$/
      if (reg.test(mobile)) {
        return true
      } else {
        return false
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.check-box {
  .form-item {
    font-size: 14px;
    margin: 15px 15px 20px;
  }
  .form-label {
    color: #757575;
    margin-bottom: 8px;
  }
  .form-input {
    display: flex;
    input {
      flex: 1;
      display: block;
      outline: none;
      border: none;
      background: #f8f8f8;
      border-radius: 5px;
      padding: 12px;
    }
  }
  .form-btn {
    margin-top: 40px;
    border-radius: 5px;
    color: #fff;
    font-size: 15px;
    height: 40px;
  }
}
</style>
